'use client';

import { createContext, useContext, type ReactNode } from 'react';

type DynamicOrderingContextValue = {
    zoneUid: string | null;
    isDynamicOrderingEnabled: boolean;
};

const DynamicOrderingContext = createContext<DynamicOrderingContextValue>({
    zoneUid: null,
    isDynamicOrderingEnabled: false
});

type ProviderProps = DynamicOrderingContextValue & { children: ReactNode };

export const DynamicOrderingProvider = ({ zoneUid, isDynamicOrderingEnabled, children }: ProviderProps) => (
    <DynamicOrderingContext.Provider value={{ zoneUid, isDynamicOrderingEnabled }}>
        {children}
    </DynamicOrderingContext.Provider>
);

export const useDynamicOrderingContext = () => useContext(DynamicOrderingContext);
